import isArray from 'lodash/isArray';
import merge from 'lodash/merge';
import Config from '@/config/index';
import { withOptimizely } from '../with-optimizely';
import { withLoggedInStatus } from '../with-logged-in-status';
import { withDevice } from '../with-device';
import { withCapturedPage } from '../with-captured-page';
export const enhanceData = (data) => {
    const newData = isArray(data) ? data : [data];
    return newData.map(item => ({
        ...item,
        additionalOptions: {
            ...merge(item.additionalOptions, {
                context: {
                    app: { build: Config.release },
                    ...withCapturedPage(),
                },
            }),
            ...withOptimizely(),
        },
        properties: {
            ...item.properties,
            ...withDevice(),
            ...withLoggedInStatus(),
        },
    }));
};
